import styleInject from '../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".SpinnerCenter-module_container__SPNje{display:grid;flex-grow:1;height:100%;place-items:center}";
var style = {"container":"SpinnerCenter-module_container__SPNje"};
styleInject(css_248z);

export { style as default };
//# sourceMappingURL=SpinnerCenter.module.css.js.map
